import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Lookup,
  SearchPanel,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { CAT, CAT_FILTER, PROVIDER, TYPE, TYPE_EXTERNAL } from "../data";

export default function CompleteList(props) {
  const { complListPopupVisible, setComplListPopupVisible, trainingTracker } =
    props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    if (trainingTracker && trainingTracker.trainee) {
      const trainee = trainingTracker.trainee.reduce(
        (acc, obj, index, array) => {
          acc += "'" + obj.trainee + "'";

          if (index < array.length - 1) {
            acc += ", ";
          }

          return acc;
        },
        ""
      );

      setDataSource(
        new CustomStore({
          key: "trainee",
          load: async () => {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trk/${trainingTracker.id}?title=${trainingTracker.title}&startDate=${trainingTracker.startDate}&dueDate=${trainingTracker.dueDate}&trainee=${trainee}`
            );

            return result.data;
          },
        })
      );
    }
  }, [trainingTracker]);

  const onHiding = () => {
    setComplListPopupVisible(false);
  };

  const calculateDisplayValue = (data) => {
    return `${data.traineeName} (${data.trainee})`;
  };

  const calculateTrainerDisplayValue = (data) => {
    if (data.trainer) {
      return `${data.trainerName} (${data.trainer})`;
    } else {
      return ``;
    }
  };

  const cellRenderTime = (data) => {
    const { time } = data.data;

    return <div>{time}h</div>;
  };

  return (
    <Popup
      visible={complListPopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title={`Training Record: ${trainingTracker.title}`}
      height={"auto"}
      width={"1250"}
      style={{
        maxHeight: "calc(100vh - 145px)",
      }}
      onHiding={onHiding}
    >
      <DataGrid
        keyExpr={"trainee"}
        dataSource={dataSource}
        allowColumnResizing={true}
        columnResizingMode="nextColumn"
        height={"auto"}
        wordWrapEnabled={true}
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        allowColumnReordering={true}
        hoverStateEnabled={true}
        columnAutoWidth={true}
      >
        <LoadPanel enabled={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} width={240} />

        <Column
          dataField={"no"}
          caption={"No"}
          dataType={"number"}
          width={70}
          allowFiltering={false}
          alignment={"center"}
        />
        <Column dataField={"trainee"} visible={false} />
        <Column
          dataField={"traineeName"}
          alignment={"center"}
          caption={"Trainee"}
          width={160}
          calculateDisplayValue={calculateDisplayValue}
        />
        <Column
          dataField={"date"}
          caption={"Date"}
          dataType={"datetime"}
          format={"yyyy-MM-ddTHH:mm:ss"}
          width={170}
          alignment={"center"}
        />
        <Column
          dataField={"cat"}
          caption={"Category"}
          width={110}
          dataType={"string"}
          alignment={"center"}
        >
          <Lookup dataSource={CAT} displayExpr={"name"} valueExpr={"id"} />
          {/* <HeaderFilter dataSource={CAT_FILTER} /> */}
        </Column>
        {/* <Column
          dataField={"title"}
          caption={"Training Title"}
          dataType={"string"}
        /> */}
        <Column
          dataField={"provider"}
          caption={"Provider"}
          width={110}
          alignment={"center"}
        >
          <Lookup dataSource={PROVIDER} displayExpr={"name"} valueExpr={"id"} />
        </Column>
        <Column
          dataField={"extProvider"}
          caption={"External Provider"}
          width={200}
        />
        <Column dataField={"type"} caption={"Type"} width={120}>
          <Lookup dataSource={TYPE} displayExpr={"name"} valueExpr={"id"} />
        </Column>
        <Column dataField={"loc"} visible={false} />
        <Column
          dataField={"time"}
          caption={"Duration"}
          dataType={"number"}
          width={110}
          cellRender={cellRenderTime}
        />
        <Column
          dataField={"trainer"}
          caption={"Trained by"}
          width={160}
          calculateDisplayValue={calculateTrainerDisplayValue}
        />
      </DataGrid>
    </Popup>
  );
}
